import React from 'react';

class CustomOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default CustomOrder;


// WEBPACK FOOTER //
// ./src/routes/customOrder/index.js